import {
	POST_DAYS_OFF,
	POST_DAYS_OFF_ERROR,
	POST_DAYS_OFF_SUCCESS,
} from '../../../constants';

export const postHolidaysReducer = (state, actions) => {
	switch (actions.type) {
		case POST_DAYS_OFF:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case POST_DAYS_OFF_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case POST_DAYS_OFF_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				holidays: actions.payload,
			};
		default:
			return state;
	}
};
